// extracted by mini-css-extract-plugin
export default {"modal":"formsmodal_modal__P9Vbi","wrapper":"formsmodal_wrapper__4zLHX"};